import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// New Firebase configuration (Updated with your new keys)
const firebaseConfig = {
  apiKey: "AIzaSyASc7eeVNEsW2UV7ViMTx9_mk55O8MjLsQ",
  authDomain: "web-app-a5469.firebaseapp.com",
  databaseURL: "https://web-app-a5469-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "web-app-a5469",
  storageBucket: "web-app-a5469.firebasestorage.app",
  messagingSenderId: "332283965159",
  appId: "1:332283965159:web:e7468fbea98e1b5a073c42"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
const db = getDatabase(app); 

// Exports (Matching your old structure)
export { db }; 
export default app;